import { render, staticRenderFns } from "./CellSelectionRegion.vue?vue&type=template&id=2d75966f&scoped=true&lang=pug"
import script from "./CellSelectionRegion.vue?vue&type=script&lang=ts"
export * from "./CellSelectionRegion.vue?vue&type=script&lang=ts"
import style0 from "./CellSelectionRegion.vue?vue&type=style&index=0&id=2d75966f&prod&scoped=true&lang=sass"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d75966f",
  null
  
)

export default component.exports